import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import {
    removeTaskConnection,
    setSelectedTask,
} from 'store/tasks/tasks.actions';
import { ITask } from 'store/tasks/tasks.state';
import { ContactItem, ContactName } from 'components';
import styles from './TaskListItem.module.scss';
import ContactCloseButton from 'components/ContactItem/ContactCloseButton';

interface TaskWithNewMessageCount extends ITask {
    newMessageCount?: number
}

interface Props {
    task: TaskWithNewMessageCount;
    selected: boolean;
    index: number;
}

const TaskListItem: React.FC<Props> = ({ task, selected, index }) => {
    const dispatch = useDispatch();

    const isTaskMissed = () =>
        task.status === connect.ContactStateType.MISSED ||
        task.status === connect.ContactStateType.ERROR;

    const onSelectTask = () => {
        dispatch(setSelectedTask(task.id));
    };

    const onCloseTask = () => {
        dispatch(removeTaskConnection(task.id));
    };

    const startDate = useMemo(() => new Date(task.started), [task.started]);

    const handleKeyPress = (evt: React.KeyboardEvent) => {
        evt.key === 'Enter' && onCloseTask();
    };

    const bodyClassName = classnames(styles.body, {
        [styles.missedContact]: isTaskMissed(),
        [styles.acw]: task.acw,
    });

    const headerClassName = classnames(styles.header, {
        [styles['header--missedContact']]: isTaskMissed(),
    });

    return (
        <ContactItem
            onSelect={onSelectTask}
            acw={task.acw}
            selected={selected}
            index={index}
            disabled={task.status === connect.ContactStateType.CONNECTING}
            isMissed={isTaskMissed()}
            className={isTaskMissed() ? styles.contactButton : ''}
            bodyClassName={bodyClassName}
            CloseButton={() => (
                <div className={styles.closeButton}>
                    <ContactCloseButton
                        onClick={onCloseTask}
                        onKeyPress={handleKeyPress}
                    />
                </div>
            )}
        >
            <div className={styles.wrapper}>
                <div className={styles.contactName}>
                    <ContactName
                        className={headerClassName}
                        name={isTaskMissed() ? 'Missed Task' : task.name}
                    />
                </div>

                {!isTaskMissed() && (
                    <p className={`${styles.description}`}>
                        {task.description}
                    </p>
                )}
            </div>
            {(!selected && task.newMessageCount) && (
                <div className={`${styles.newMessageCount}`}>
                    <p>{task.newMessageCount}</p>
                </div>
            )}
        </ContactItem>
    );
};

export default TaskListItem;
